<template>
    <div>
        <LocationSelector :locations="locations" :value="value.locations" @input="updateLocations" />
        <div class="wrapper">
            <SelectBox
                id="forAT_AddWidget-callType"
                :placeholder="$t('reporting.commonLabels.callType')"
                :value="value.call_type"
                :options="callTypes"
                @input="updateCallType"
            />
        </div>
        <div class="wrapper">
            <SelectBox
                id="forAT_AddWidget-processing"
                :placeholder="$t('dashboard.labels.callProcessingType')"
                :value="value.processing_time"
                :options="processing"
                @input="updateProcessingTime"
            />
        </div>
    </div>
</template>

<script>
import SelectBox from './../../common/SelectBox.vue';
import LocationSelector from './common/LocationSelector.vue';
import { mapState } from 'vuex';
import { translateOptions, processing as processingArray, createUpdaters } from '../widgetHelpers';

export default {
    components: {
        LocationSelector,
        SelectBox,
    },

    props: {
        locations: {
            type: Array,
            required: true,
        },

        value: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapState({
            callTypes: state => state.callTypes.map(({ id, name }) => ({ value: id, name })),
        }),

        /**
         * Returns a list of options for processing dropdown
         * {{ name: string, value: number }[]}
         */
        processing() {
            return translateOptions(this.$t.bind(this), processingArray);
        },
    },

    methods: createUpdaters('locations', 'call_type', 'processing_time'),
};
</script>
